module.exports = __webpack_public_path__ + "media/images/exclamation_mark-2f72e46fa05dac71f13aab4b842fdb2f.png";